import { render, staticRenderFns } from "./DraftArticleBody.vue?vue&type=template&id=6cf25d5d&"
import script from "./DraftArticleBody.vue?vue&type=script&lang=js&"
export * from "./DraftArticleBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports